<template>
  <div class="full" ref="mounter">
    <a class="aroundbtn" href="/exp">
      Experiment
      <br />
      {{ message }}
      <!-- <img class="homebtn w-16 h-16 lg:w-32 lg:h-32" src="../assets/home/jelly-button-blue.svg" alt="Home"> -->
    </a>
  </div>
</template>

<script>
import * as GSTube from '../GLs/GSTube'
export default {
  components: {
  },
  data () {
    return {
      message: '',
      rAPI: false
    }
  },
  async mounted () {
    this.rAPI = await GSTube.install({ mounter: this.$refs['mounter'], vm: this })
  },
  beforeDestroy () {
    this.rAPI.clean()
  }
}
</script>

<style lang="postcss">
.homebtn{
  /* background-color: white; */
}
.aroundbtn{
  padding: 20px;
  border-radius: 200px;
  position: absolute;
  display: block;
  top: 20px;
  left: 20px;
  z-index: 100000;
  background-color: rgba(0,0,0,0.6);
  color: white;
}
</style>
